import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Langue d'affichage des pages bilingues (CV, À propos), partagée entre les pages :
// 1. ?lang=en / ?lang=fr dans l'adresse (lien partageable)
// 2. sinon le dernier choix du visiteur
// 3. sinon l'anglais pour un navigateur en anglais, le français pour les autres
const STORAGE_KEY = 'siteLang';

const initialLang = (param) => {
  if (param === 'en' || param === 'fr') return param;
  try {
    const saved = localStorage.getItem(STORAGE_KEY) || localStorage.getItem('cvLang');
    if (saved === 'en' || saved === 'fr') return saved;
  } catch {}
  return (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'fr';
};

export function useSiteLang() {
  const [params, setParams] = useSearchParams();
  const [lang, setLangState] = useState(() => initialLang(params.get('lang')));

  // langue de la page (lecteurs d'écran, traduction automatique du navigateur)
  useEffect(() => {
    document.documentElement.lang = lang;
    return () => { document.documentElement.lang = 'fr'; };
  }, [lang]);

  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
    const next = new URLSearchParams(params);
    if (l === 'en') next.set('lang', 'en'); else next.delete('lang');
    setParams(next, { replace: true });
  };

  return [lang, setLang];
}

export default function LangToggle({ lang, onChange, label = 'Langue' }) {
  return (
    <div className="cv-lang-toggle" role="group" aria-label={label}>
      <button type="button" lang="fr" aria-pressed={lang === 'fr'} className={lang === 'fr' ? 'on' : ''} onClick={() => onChange('fr')}>FR</button>
      <button type="button" lang="en" aria-pressed={lang === 'en'} className={lang === 'en' ? 'on' : ''} onClick={() => onChange('en')}>EN</button>
    </div>
  );
}
